import React, { useRef } from 'react';
import './CanvasColorInput.styles.scss';

interface CanvasColorInputProps {
    label?: string;
    color?: string;
    onChangeColor?: (color: string) => void;
}

const CanvasColorInput: React.FC<CanvasColorInputProps> = ({ label = 'Background', color, onChangeColor }) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleOpen = () => {
        inputRef.current?.click();
    };

    const handleChangeColor = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChangeColor?.(event.target.value);
    };

    return (
        <div className="canvas-color-input" onPointerDown={handleOpen}>
            <span className="canvas-color-input__label">{label}</span>
            <span className="canvas-color-input__circle" style={{ background: color }} />
            <input
                ref={inputRef}
                type="color"
                className="canvas-color-input__input"
                value={color}
                onChange={handleChangeColor}
            />
        </div>
    );
};

export default CanvasColorInput;